// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs-3bDXy","tab":"tab-T_7_M","label":"label-xGA9K","description":"description-10Gql","underline":"underline-zEG8p","line":"line-21Zzw","lineInvert":"lineInvert-2xZsp"};